.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}
.row {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--sp-3);
  font-size: 10.5px;
}
.label {
  color: var(--text2);
}
.value {
  font-family: var(--font-mono);
  font-weight: 600;
  color: var(--text);
}
.track {
  height: 6px;
  border-radius: 3px;
  background: var(--surf2);
  overflow: hidden;
}
.fill {
  height: 100%;
  /* 4px rounded data-end, anchored flat to the baseline. */
  border-radius: 0 4px 4px 0;
  transition: width 0.35s ease;
}
